export default __webpack_public_path__ + "static/media/collection_full.a48bf474.png";